import React from "react";
import { TitleText } from "../../../ui/Text";
import styled from "styled-components";

interface CardProps {
  title: string;
  name: string;
  icon?: React.ReactNode;
}
const NameCard = ({ title, name, icon }: CardProps) => {
  return (
    <NameCardContainer>
      <NameSection>
        <Text>{title}</Text>
        <TitleText>{name}</TitleText>
      </NameSection>
      {icon ? icon : null}
    </NameCardContainer>
  );
};

export default NameCard;

const NameCardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5em 1.4em;
  background-color: #f5f6fb;
  border-radius: 0.5em;
  margin: 1em 1.5em;
  padding: 1.5em;
`;
const NameSection = styled.div`
  display: flex;
  align-items: baseline;
  flex-direction: column;
`;

const Text = styled.h4`
  margin: 0;
  font-size: 0.875em;
  font-weight: normal;
  color: #01A8CE;
  opacity: 0.3;
  line-height: 24px;
`;
